module.exports = __webpack_public_path__ + "static/media/table_julialuz2.0adf8fed.png";